export default __webpack_public_path__ + "static/media/ProfileImage.24bf92c4.jpg";